import React from 'react';
import BackToChatLink from './BackToChatLink';
import './PageHeader.css';

/**
 * The ONE page header of every global app page (Nitish, Sep 15 2026 02:30 ET, after measuring five
 * pages at four title sizes, two font families and three content widths): Tasks, Routines,
 * Projects, Connectors, Cold Outreach. Nothing else may draw a page title.
 *
 * Title 24px / 650 (22px on phones), the app's system font; one muted line under it; the page's
 * primary action(s) trailing on the title row; 24px above (the --cc-page-pad-top token, applied by
 * the page container) and 24px below to the first content. The header takes whichever container
 * its page uses: work surfaces (Tasks, Routines) run full width, reading pages (Connectors, Cold
 * Outreach, Projects) sit in the --cc-page-max-width column; both share the same side padding, so
 * on a laptop every title sits at the same left edge and height.
 *
 * Props: title (string) · subtitle (one sentence; optional) · actions (node; optional) · className.
 *
 * "← Back to chat" (CEL-3662) renders above the title by itself when the page was opened from a chat
 * with `?back=` (BackToChatLink); otherwise nothing changes.
 */
const PageHeader = ({ title, subtitle, actions, className = '' }) => (
  <header className={`cc-page-header ${className}`.trim()}>
    <div className="cc-page-header-text">
      <BackToChatLink />
      <h1 className="cc-page-header-title">{title}</h1>
      {subtitle && <p className="cc-page-header-sub">{subtitle}</p>}
    </div>
    {actions && <div className="cc-page-header-acts">{actions}</div>}
  </header>
);

export default PageHeader;
